import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { marketing } from '../services/api';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

/** Public landing page for the Resend confirmation link (/confirm-signup/:token). */
export default function ConfirmSliderSignup() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, ok: false, data: null, err: null });

  useEffect(() => {
    (async () => {
      try {
        const r = await marketing.sliderFormConfirm(token);
        setState({ loading: false, ok: true, data: r, err: null });
      } catch (err) {
        setState({ loading: false, ok: false, data: null, err: err?.response?.data?.detail || 'Invalid or expired link.' });
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-neutral-950 text-white flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-neutral-900 border border-neutral-800 rounded-2xl p-8 text-center space-y-4"
           data-testid="confirm-slider-signup">
        {state.loading && (
          <>
            <Loader2 size={44} className="animate-spin text-green-500 mx-auto"/>
            <div className="text-lg font-bold">Confirming your subscription…</div>
          </>
        )}
        {!state.loading && state.ok && (
          <>
            <CheckCircle2 size={56} className="text-green-500 mx-auto"/>
            <div className="text-2xl font-black">You're in!</div>
            <div className="text-sm text-gray-300">
              You'll now receive deals from <b>{state.data?.businessName || 'this business'}</b>.
            </div>
            <Link to="/" className="inline-block mt-3 px-5 py-2 rounded-full bg-green-600 hover:bg-green-500 text-white text-sm font-semibold">
              Back to home
            </Link>
          </>
        )}
        {!state.loading && !state.ok && (
          <>
            <XCircle size={56} className="text-red-500 mx-auto"/>
            <div className="text-2xl font-black">Can't confirm</div>
            <div className="text-sm text-gray-300">{state.err}</div>
            <Link to="/" className="inline-block mt-3 px-5 py-2 rounded-full border border-neutral-700 hover:bg-neutral-800 text-white text-sm font-semibold">
              Back to home
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
